import React from 'react';

export const CodeMonkey = ({ className = '', size = 200 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="FLUMBERICO Code Monkey mascot - a cartoon monkey with coding symbols representing SEO and link building"
    >
      <title>FLUMBERICO Code Monkey Mascot</title>
      <desc>A friendly cartoon monkey character surrounded by coding symbols including HTML tags, brackets, and SEO text, representing the FLUMBERICO SEO token project</desc>
      {/* Monkey Head */}
      <ellipse cx="100" cy="90" rx="60" ry="70" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      
      {/* Ears */}
      <ellipse cx="50" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="70" rx="20" ry="25" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="50" cy="75" rx="12" ry="15" fill="#B8860B"/>
      <ellipse cx="150" cy="75" rx="12" ry="15" fill="#B8860B"/>
      
      {/* Face */}
      <ellipse cx="100" cy="110" rx="45" ry="35" fill="#B8860B"/>
      
      {/* Eyes */}
      <circle cx="85" cy="90" r="8" fill="white"/>
      <circle cx="115" cy="90" r="8" fill="white"/>
      <circle cx="87" cy="92" r="5" fill="black"/>
      <circle cx="117" cy="92" r="5" fill="black"/>
      
      {/* Nose */}
      <ellipse cx="100" cy="105" rx="8" ry="6" fill="#8B7355"/>
      
      {/* Mouth - smiling */}
      <path d="M 90 115 Q 100 125 110 115" stroke="#8B7355" strokeWidth="2" fill="none"/>
      
      {/* Code symbols floating around */}
      <text x="20" y="30" fill="#FFD700" fontSize="16" fontFamily="monospace" className="animate-pulse">&lt;/&gt;</text>
      <text x="160" y="30" fill="#C0C0C0" fontSize="14" fontFamily="monospace" className="animate-pulse">{'{}'}</text>
      <text x="10" y="130" fill="#FFD700" fontSize="12" fontFamily="monospace" className="animate-pulse">SEO</text>
      <text x="165" y="140" fill="#C0C0C0" fontSize="12" fontFamily="monospace" className="animate-pulse">#1</text>
      
      {/* Body - simplified */}
      <rect x="70" y="145" width="60" height="40" rx="10" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      
      {/* Arms */}
      <ellipse cx="50" cy="165" rx="15" ry="30" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      <ellipse cx="150" cy="165" rx="15" ry="30" fill="#C9B037" stroke="#FFD700" strokeWidth="2"/>
      
      {/* Laptop/Keyboard */}
      <rect x="55" y="175" width="90" height="15" rx="2" fill="#2C2C2C" stroke="#FFD700" strokeWidth="1"/>
      <rect x="60" y="178" width="20" height="3" rx="1" fill="#FFD700"/>
      <rect x="85" y="178" width="30" height="3" rx="1" fill="#C0C0C0"/>
      <rect x="120" y="178" width="20" height="3" rx="1" fill="#FFD700"/>
    </svg>
  );
};